import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

export default function parseSuspectedDisplayNameEmailAddress(
    parseString: string
): FindRecipientPersonaType {
    if (parseString) {
        // We will start with an example string of 'Hello Kitty (OUTLOOK) <hello.kitty@microsoft.com>'
        // Prepare the string by trimming excess quotes.
        parseString = parseString.replace(/['"]+/g, '');
        parseString = parseString.trim();

        // Split on various potential opening brackets: '(', '[', '{'
        // EX 'Hello Kitty ', '(', ' OUTLOOK) ', '<', 'hello.kitty@microsoft.com>'
        let splits = parseString.split(/([<\[\({])+/g);
        let displayName;
        let emailAddress = parseString;

        // With longer than three splits (means there was at least one opening bracket found...
        if (splits.length >= 3) {
            // Piece together all the parts except for the last opening bracket match and the last part
            // EX 'Hello Kitty (OUTLOOK)'
            displayName = splits
                .slice(0, splits.length - 2)
                .join('')
                .trim();
            // That last part is hopefully the email address, so we split on closing brackets and take the first match.
            // EX 'hello.kitty@microsoft.com>' -> 'hello.kitty@microsoft.com', '>', so we take the first split.
            emailAddress = splits[splits.length - 1].split(/([>\]\)}])+/g)[0].trim();
        }
        return {
            EmailAddress: {
                MailboxType: 'OneOff',
                RoutingType: 'SMTP',
                EmailAddress: emailAddress,
                Name: displayName ? displayName : emailAddress,
            },
        };
    } else {
        return {
            EmailAddress: {
                EmailAddress: parseString,
            },
        };
    }
}
